import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { SegmentoEmpleado } from '../_models/segmento-empleado';

@Injectable({
  providedIn: 'root'
})
export class SegmentoEmpleadoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/segmentosEmpleados';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as SegmentoEmpleado[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as SegmentoEmpleado[] ) );
  }

  obtenerPorSegmento( idSegmento: string ) {
    return this.httClient.get( this.rutServicio + '/segmento/' + idSegmento ).pipe( map( res => res as SegmentoEmpleado[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as SegmentoEmpleado ) );
  }

  agregar( regCrear: SegmentoEmpleado ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as SegmentoEmpleado ) );
  }

  actualizar( regActualizar: SegmentoEmpleado ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as SegmentoEmpleado ) );
  }

}
